import { j as e } from "./jsx-runtime-DywqP_6a.js";
import { d as m, f as p } from "./ZudokuContext-BcqSiygJ.js";
import { H as h } from "./index.esm-BnYHxCYC.js";
import { createContext as f, use as g } from "react";
import { b as x, c as j, m as y, O as w } from "./chunk-PVWAREVJ-BO6B-RAk.js";
import { D as b, a as R, b as C, c as D, d as P } from "./Dialog-VIMic7xI.js";
import { a as T } from "./hook-BkLXq8pm.js";
import { Z as E } from "./invariant-Bm-FVUQE.js";
import { u as v } from "./useLatest-hmRS46UF.js";
const O = f(!1), A = "protected", N = () => {
  const o = T(), n = m(), d = x(), s = j(), l = v(s.pathname), a = g(O), { protectedRoutes: i } = n.options, r = !a && i ? Object.entries(i).find(
    ([t]) => y({ path: t, end: !0 }, s.pathname)
  )?.[1] : void 0, u = r !== void 0, c = u && !r({ auth: o, context: n });
  if (p({
    queryKey: ["login-redirect"],
    queryFn: async () => (await new Promise((t) => setTimeout(t, 1200)), await n.authentication?.signIn({
      redirectTo: l.current
    }), !0),
    enabled: typeof window < "u" && c && !o.isPending
  }), c)
    return /* @__PURE__ */ e.jsx(
      b,
      {
        open: !0,
        onOpenChange: (t) => {
          t || d(-1);
        },
        children: /* @__PURE__ */ e.jsxs(R, { children: [
          /* @__PURE__ */ e.jsx(C, { children: /* @__PURE__ */ e.jsx(D, { children: "Logging you in..." }) }),
          /* @__PURE__ */ e.jsx(P, { children: "Please wait while we log you in." })
        ] })
      }
    );
  if (u && !o.isAuthEnabled)
    throw new E("Authentication is not enabled", {
      title: "Authentication is not enabled",
      developerHint: "To use protectedRoutes you need authentication to be enabled"
    });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    a && /* @__PURE__ */ e.jsx(h, { children: /* @__PURE__ */ e.jsx(
      "meta",
      {
        name: "pagefind",
        "data-pagefind-filter": `section:${A}`,
        content: "true"
      }
    ) }),
    /* @__PURE__ */ e.jsx(w, {})
  ] });
};
export {
  O as B,
  N as R,
  A as S
};
//# sourceMappingURL=RouteGuard-dji1UEYe.js.map
